module.exports = __webpack_public_path__ + "static/media/CTLA_6-135w.d90626fb.webp";